module.exports = __webpack_public_path__ + "img/twism-full-logo-light.38bcfb59.svg";